import { render, staticRenderFns } from "./VisitItemList.vue?vue&type=template&id=af03df34&scoped=true&"
import script from "./VisitItemList.vue?vue&type=script&lang=js&"
export * from "./VisitItemList.vue?vue&type=script&lang=js&"
import style0 from "./VisitItemList.vue?vue&type=style&index=0&id=af03df34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03df34",
  null
  
)

export default component.exports